// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","868":"feba08b6","1077":"b8ad3859","2916":"feba08b6","3266":"b8ad3859"}[chunkId] + ".chunk.css";
};